<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <mat-form-field *ngIf="isRoleLabelVisible">
        <mat-label> {{ 'GENERAL.PROPERTY.ROLE' | translate }}</mat-label>
        <input matInput [(ngModel)]="roleLabel" />
    </mat-form-field>

    <ng-container *ngIf="list.length">
        <h3 class="mb-8 text-base font-medium text-gray-600">{{ 'GENERAL.LABEL.SELECTED_USERS' | translate }}</h3>
        <mat-chip-set class="chip-list wrap">
            <mat-chip class="chip maxbrain-500" [removable]="removable" (removed)="removeFromList(item)" *ngFor="let item of list">
                {{ item.fullName }}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
        </mat-chip-set>
    </ng-container>

    <div fxLayout="row" fxLayoutAlign="flex-end center" class="mb-12 mt-16">
        <app-search-outline [searchInput]="searchInput"></app-search-outline>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" class="bg-zinc-50 p-16 mb-24" *ngIf="audienceRelevantExperiences.length">
        <div fxLayout="row" fxLayoutAlign="start baseline" class="text-truncate pr-12">
            <span class="text-gray-500">{{ 'ENGAGE.AUDIENCE.LABELS.FILTERED_BY_EXPERIENCE' | translate }}:</span>
            <span>&nbsp;</span>
            <span class="text-black text-truncate" *ngFor="let relevantExperience of audienceRelevantExperiences; let last = last">
                {{ relevantExperience.experience.name }}<span *ngIf="!last">,&nbsp;</span>
            </span>
        </div>

        <div fxLayout="row" fxLayoutAlign="flex-end center" class="pointer" (click)="navigateToChangeExperience()">
            <span class="text-primary-500 mr-4">{{ 'PAGE.ENGAGE.TAB.EXPERIENCE.BUTTONS.CHANGE_EXPERIENCE' | translate }}</span>
            <mat-icon class="text-primary-500">keyboard_arrow_right</mat-icon>
        </div>
    </div>

    <div class="w-100-p table-wrapper" *ngIf="dataSource">
        <mat-table #table [dataSource]="dataSource" matSort>
            <!-- Avatar Column -->
            <ng-container matColumnDef="avatar">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let user">
                    <div class="relative" #avatarCell>
                        <img class="avatar" *ngIf="user?.avatar.src; else initials" [alt]="user.fullName" [src]="user.avatar.src" />
                        <ng-template #initials>
                            <div fxLayoutAlign="center center" class="avatar-initials avatar">{{ user.fullName | initials }}</div>
                        </ng-template>
                        <ng-template [onlineStateIndicator]="user.isOnline"> </ng-template>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- First Name Column -->
            <ng-container matColumnDef="firstName">
                <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header> {{ 'GENERAL.PROPERTY.FIRST_NAME' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let user" class="narrow">
                    <p class="text-truncate font-semibold min-w-0 max-w-full" [tooltipIfTruncated]="user.firstName">
                        {{ user.firstName }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Last Name Column -->
            <ng-container matColumnDef="lastName">
                <mat-header-cell class="narrow" *matHeaderCellDef mat-sort-header>
                    {{ 'GENERAL.PROPERTY.LAST_NAME' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user" class="narrow">
                    <p class="text-truncate font-semibold min-w-0 max-w-full" [tooltipIfTruncated]="user.lastName">
                        {{ user.lastName }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="email">
                <mat-header-cell class="wider" *matHeaderCellDef mat-sort-header fxHide fxShow.gt-xs>
                    {{ 'GENERAL.PROPERTY.EMAIL' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let user" fxHide fxShow.gt-xs>
                    <p class="text-truncate font-semibold min-w-0 max-w-full" [tooltipIfTruncated]="user.email">{{ user.email }}</p>
                </mat-cell>
            </ng-container>

            <!-- Buttons Column -->
            <ng-container matColumnDef="buttons">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let user">
                    <div fxFlex="row" fxLayoutAlign="end center">
                        <app-flat-button
                            [label]="'GENERAL.BUTTON.ADD'"
                            (onClick)="addToList(user)"
                            *ngIf="!user.alreadyMember && !user.selected && !isChat && isUserSelectable(user)"
                        ></app-flat-button>
                        <span
                            *ngIf="!user.alreadyMember && !user.selected && !isChat && !isUserSelectable(user)"
                            [matTooltip]="getUserDisabledReasonTranslationKey(user) | translate"
                            [matTooltipDisabled]="!getUserDisabledReasonTranslationKey(user)"
                            matTooltipPosition="above"
                        >
                            <app-white-button [label]="'GENERAL.BUTTON.ADD'" [disabled]="true"></app-white-button>
                        </span>
                        <app-flat-button [label]="'GENERAL.PROPERTY.SEND_MESSAGE'" [svgIcon]="'chat_bubble'" (onClick)="confirm(user)" *ngIf="isChat"></app-flat-button>
                        <p *ngIf="user.alreadyMember && !isChat">{{ 'GENERAL.LABEL.IN_GROUP' | translate }}</p>
                        <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(user)" *ngIf="user.selected && !isChat"></app-white-button>
                    </div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let user; columns: displayedColumns" class="user" matRipple> </mat-row>
        </mat-table>
        <mat-paginator persistPageSize="group.select-group-members-dialog"
            *ngIf="!isManualDataSourceMode"
            [length]="hasNoRelevantExperiences ? 0 : isChat ? (totalCountChatUsers$ | async) : (totalCount$ | async)"
            [pageSize]="5"
            [pageSizeOptions]="[5, 10, 25, 50]"
        >
        </mat-paginator>
    </div>
</div>

<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center" *ngIf="!isChat">
    <mat-slide-toggle class="mr-16" *ngIf="showAssignAsTrainingApproverToggle" [(ngModel)]="assignAsTrainingResponsible">
        {{ 'TEAMS.LEAD.TOGGLE.ASSIGN_AS_TRAINING_APPROVER' | translate }}
    </mat-slide-toggle>
    <div class="example-spacer" *ngIf="showAssignAsTrainingApproverToggle"></div>
    <mat-checkbox *ngIf="isNotifyCheckboxVisible" class="mr-24" [(ngModel)]="notifyMembers">
        {{ notifyText | translate }}
    </mat-checkbox>
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" [disabled]="0 === list.length" (onClick)="saveSelected()"></app-flat-button>
</div>
